module.exports = __webpack_public_path__ + "img/coin.3b8488d9.svg";